import { render } from "./Usage.vue?vue&type=template&id=55ac6f24"
import script from "./Usage.vue?vue&type=script&lang=ts"
export * from "./Usage.vue?vue&type=script&lang=ts"
script.render = render

export default script